import APILayout from "@/components/Layout/APILayout";
import RecruitMoreLayout from "@/domain/recruitMore/Layout/RecruitMoreLayout";

const RecruitMore = () => {
    return (
        <APILayout>
            <RecruitMoreLayout></RecruitMoreLayout>
        </APILayout> 
    );
};

export default RecruitMore;
